<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4961 4.27344C12.3555 4.30859 12.25 4.48438 12.25 4.625C12.25 4.80078 12.3555 4.97656 12.4961 5.01172L14.5 5.75L15.2383 7.75391C15.2734 7.89453 15.4492 8 15.625 8C15.7656 8 15.9414 7.89453 15.9766 7.75391L16.75 5.75L18.7188 5.01172C18.8945 4.97656 19 4.80078 19 4.625C19 4.48438 18.8945 4.30859 18.7188 4.27344L16.75 3.5L15.9766 1.53125C15.9414 1.35547 15.7656 1.25 15.625 1.25C15.4492 1.25 15.2734 1.35547 15.2383 1.53125L14.5 3.5L12.4961 4.27344ZM8.20703 3.85156C8.10156 3.64062 7.89062 3.5 7.67969 3.5C7.46875 3.5 7.25781 3.64062 7.1875 3.85156L5.32422 7.85938L1.31641 9.6875C1.10547 9.79297 1 10.0039 1 10.2148C1 10.4258 1.10547 10.6367 1.31641 10.7422L5.32422 12.5703L7.1875 16.5781C7.25781 16.7891 7.46875 16.9297 7.67969 16.9297C7.89062 16.9297 8.10156 16.7891 8.20703 16.5781L10.0352 12.5703L14.043 10.707C14.2539 10.6367 14.3945 10.4258 14.3945 10.2148C14.3945 10.0039 14.2539 9.79297 14.043 9.6875L10.0352 7.85938L8.20703 3.85156ZM14.5 14.75L12.4961 15.5234C12.3555 15.5586 12.25 15.7344 12.25 15.875C12.25 16.0508 12.3555 16.2266 12.4961 16.2617L14.5 17L15.2383 19.0039C15.2734 19.1445 15.4492 19.25 15.625 19.25C15.7656 19.25 15.9414 19.1445 15.9766 19.0039L16.75 17L18.7188 16.2617C18.8945 16.2266 19 16.0508 19 15.875C19 15.7344 18.8945 15.5586 18.7188 15.5234L16.75 14.75L15.9766 12.7812C15.9414 12.6055 15.7656 12.5 15.625 12.5C15.4492 12.5 15.2734 12.6055 15.2383 12.7812L14.5 14.75Z"
      fill="#F7F7F8"
    />
    <path
      d="M12.4961 4.27344C12.3555 4.30859 12.25 4.48438 12.25 4.625C12.25 4.80078 12.3555 4.97656 12.4961 5.01172L14.5 5.75L15.2383 7.75391C15.2734 7.89453 15.4492 8 15.625 8C15.7656 8 15.9414 7.89453 15.9766 7.75391L16.75 5.75L18.7188 5.01172C18.8945 4.97656 19 4.80078 19 4.625C19 4.48438 18.8945 4.30859 18.7188 4.27344L16.75 3.5L15.9766 1.53125C15.9414 1.35547 15.7656 1.25 15.625 1.25C15.4492 1.25 15.2734 1.35547 15.2383 1.53125L14.5 3.5L12.4961 4.27344ZM8.20703 3.85156C8.10156 3.64062 7.89062 3.5 7.67969 3.5C7.46875 3.5 7.25781 3.64062 7.1875 3.85156L5.32422 7.85938L1.31641 9.6875C1.10547 9.79297 1 10.0039 1 10.2148C1 10.4258 1.10547 10.6367 1.31641 10.7422L5.32422 12.5703L7.1875 16.5781C7.25781 16.7891 7.46875 16.9297 7.67969 16.9297C7.89062 16.9297 8.10156 16.7891 8.20703 16.5781L10.0352 12.5703L14.043 10.707C14.2539 10.6367 14.3945 10.4258 14.3945 10.2148C14.3945 10.0039 14.2539 9.79297 14.043 9.6875L10.0352 7.85938L8.20703 3.85156ZM14.5 14.75L12.4961 15.5234C12.3555 15.5586 12.25 15.7344 12.25 15.875C12.25 16.0508 12.3555 16.2266 12.4961 16.2617L14.5 17L15.2383 19.0039C15.2734 19.1445 15.4492 19.25 15.625 19.25C15.7656 19.25 15.9414 19.1445 15.9766 19.0039L16.75 17L18.7188 16.2617C18.8945 16.2266 19 16.0508 19 15.875C19 15.7344 18.8945 15.5586 18.7188 15.5234L16.75 14.75L15.9766 12.7812C15.9414 12.6055 15.7656 12.5 15.625 12.5C15.4492 12.5 15.2734 12.6055 15.2383 12.7812L14.5 14.75Z"
      fill="url(#paint0_linear_3778_740)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3778_740"
        x1="3.97843"
        y1="4"
        x2="13.9449"
        y2="16.1042"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="ai-icon__stop-start" />
        <stop class="ai-icon__stop-end" offset="1" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style scoped>
/* Bright gradient works great on dark surfaces (default). */
.ai-icon__stop-start {
  stop-color: #84e110;
}
.ai-icon__stop-end {
  stop-color: #02f5d8;
}

/* On the light theme the bright green/teal washes out on the light-gray
   button background, so switch to a darker, more saturated gradient. */
[data-mode="light"] .ai-icon__stop-start {
  stop-color: #469100;
}
[data-mode="light"] .ai-icon__stop-end {
  stop-color: #009c86;
}
</style>
